import React from "react";
import classnames from "classnames";
import find from "lodash/find";
import { connect } from "react-redux";
import * as actions from "../../actions/actions";
import StripeCardElement from "../stripe-card-element";
import ToolTip from "../tool-tip";
import PurchaseType from "./purchase-type";
import ProDownloadDescription from "./pro-download-description";

import { licenses } from "../../reducers/download";
import { PREPAID_TYPE } from "../../reducers/stripe";

import "intl";
import "intl/locale-data/jsonp/en.js";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

class IconPaymentForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleCardComplete = this.handleCardComplete.bind(this);
        this.handleSaveCardChange = this.handleSaveCardChange.bind(this);
        this.handleBillingInfoChange = this.handleBillingInfoChange.bind(this);
        this.doPurchase = this.doPurchase.bind(this);
    }
    componentDidMount() {
        if (
            this.props.user &&
            !this.props.user.is_anonymous &&
            this.props.user.has_credit_card
        ) {
            this.props.stripeGetSavedCard(true);
        }
    }
    handleCardComplete(stripeApi) {
        this.setState({
            stripeApi
        });
    }
    handleSaveCardChange(evt) {
        const { target } = evt;
        const value =
            target.type === "checkbox" ? target.checked : target.value;
        this.props.stripeSaveCardChange(value);
    }
    handleBillingInfoChange(evt) {
        const { target } = evt;
        const value =
            target.type === "checkbox" ? target.checked : target.value;
        this.props.stripeUpdateBillingInfo(value);
    }
    doPurchase() {
        this.props.downloadPurchase(this.state.stripeApi);
    }
    canPurchase() {
        let noCardCanPurchase =
            (!this.props.savedCard || this.props.useNewCard) &&
            !!this.state.stripeApi;
        let savedCardCanPurchase =
            !!this.props.savedCard && !this.props.useNewCard;
        return (
            !!this.props.currentPurchase &&
            (noCardCanPurchase || savedCardCanPurchase)
        );
    }
    render() {
        let {
            currentPurchase,
            saveCard,
            savedCard,
            useNewCard,
            billingInfo,
            processing,
            download
        } = this.props;

        let paymentOption = (
            <PurchaseType
                key={currentPurchase.key}
                purchaseType={currentPurchase}
                currentPurchase={currentPurchase}
            />
        );
        let chooseAnother = (
            <div
                className="link-action choose-another"
                onClick={this.props.downloadResetToLicense.bind(
                    null,
                    download.pendingDownload,
                    licenses.ROYALTY_FREE
                )}
            >
                Choose a different way to pay
            </div>
        );

        let buttonClass = classnames("button", {
            lightgray: !this.canPurchase(),
            blue: this.canPurchase() && !processing,
            processing
        });

        let { stripeError } = this.props;
        let error;
        if (stripeError) {
            error = <div className="error stripe-error">{stripeError}</div>;
        }
        let noSavedCard = !savedCard;
        let usingSavedCard = !!savedCard && !useNewCard;
        let changingSavedCard = savedCard && useNewCard;

        let saveCardInput;
        let whatToPurchase = "Icon";
        if (currentPurchase) {
            if (!currentPurchase.period) {
                if (noSavedCard || changingSavedCard) {
                    let verb = changingSavedCard ? "Replace" : "Save";
                    saveCardInput = (
                        <div className="save-card-section">
                            <label htmlFor="save_card">{verb} card</label>
                            <div className="fancy-checkbox blue">
                                <input
                                    id="save_card"
                                    name="save_card"
                                    type="checkbox"
                                    checked={saveCard}
                                    onChange={this.handleSaveCardChange}
                                />
                                <label htmlFor="save_card" />
                            </div>
                        </div>
                    );
                }
                if (currentPurchase.type == PREPAID_TYPE) {
                    whatToPurchase = "Prepaid Balance";
                }
            } else {
                whatToPurchase = "Subscription";
            }
        }

        let cardDisplay;
        if (!savedCard || useNewCard) {
            cardDisplay = (
                <StripeCardElement
                    stripePublishableKey={this.props.stripePublishableKey}
                    handleComplete={this.handleCardComplete}
                    handleChange={this.props.stripeCardInputChange}
                    handleError={this.props.stripeCardInputError}
                />
            );
        } else {
            cardDisplay = (
                <div className="saved-card">
                    <div className="card-number">
                        {savedCard.card_number.replace(/\*/g, "•")}
                    </div>
                    <div className="card-expiration">
                        {savedCard.card_expiration}
                    </div>
                    <div className="card-cvc">
                        {savedCard.card_cvc.replace(/\*/g, "•")}
                    </div>
                </div>
            );
        }

        let dueNow;
        if (currentPurchase) {
            let priceDisplay = formatter.format(currentPurchase.price / 100, 2);
            if (!currentPurchase.price) {
                priceDisplay = "-";
            }
            dueNow = (
                <div className="purchase-total">
                    Charged today <span>{priceDisplay}</span>
                </div>
            );
        }

        let savedCardAction;
        if (useNewCard && savedCard) {
            savedCardAction = (
                <div
                    className="link-action saved-card-action"
                    onClick={this.props.stripeUseNewCard}
                >
                    Use saved card
                </div>
            );
        } else if (savedCard) {
            savedCardAction = (
                <div
                    className="link-action saved-card-action"
                    onClick={this.props.stripeUseNewCard}
                >
                    Use different card
                </div>
            );
        }

        let billingInfoClass = classnames("billing-info", {
            "billing-info-empty": !billingInfo || !billingInfo.trim()
        });

        let billingInfoDisplay = (
            <div className={billingInfoClass}>
                <h5 className="billing-header">
                    Optional billing info{" "}
                    <ToolTip>
                        <p>
                            This information shows on your invoices, some people
                            need this for tax purposes. You can change it later.
                            It is great for VAT, Address, Job Number, Etc.
                        </p>
                    </ToolTip>
                </h5>
                <textarea
                    placeholder="VAT Numbers, Address, etc."
                    data-testid="receipt-info"
                    value={billingInfo || ""}
                    onChange={this.handleBillingInfoChange}
                />
            </div>
        );

        let purchaseDisclaimer, buyingSubscription;
        if (currentPurchase) {
            purchaseDisclaimer = (
                <p className="disclaimer">{currentPurchase.description}</p>
            );
        }

        let formClass = classnames("billing-form", {
            "with-stripe-error": !!error,
            "with-purchase-selected": !!currentPurchase
        });
        return (
            <React.Fragment>
                <ProDownloadDescription />
                <div className={formClass}>
                    <ul className="purchase-types bubble-choices blue-choices">
                        {paymentOption}
                    </ul>
                    {chooseAnother}
                    {dueNow}
                    {purchaseDisclaimer}
                    <div className="card-section">
                        <h5 className="billing-header">
                            Credit Card {saveCardInput}
                        </h5>
                        {cardDisplay}
                        {error}
                    </div>
                    {savedCardAction}
                    {billingInfoDisplay}
                    <button className={buttonClass} onClick={this.doPurchase}>
                        Purchase {whatToPurchase}
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let { stripe, user, download } = state;

    let { stripe: stripePublishableKey } = user;
    let { processing } = download;
    let {
        purchaseTypes,
        currentPurchaseKey,
        error,
        saveCard,
        savedCard,
        useNewCard,
        billingInfo
    } = stripe;

    let currentPurchase = find(purchaseTypes, { key: currentPurchaseKey });

    return {
        processing,
        purchaseTypes,
        currentPurchase,
        stripeError: error,
        saveCard,
        savedCard,
        useNewCard,
        user,
        billingInfo,
        stripePublishableKey
    };
}

export default connect(
    mapStateToProps,
    {
        downloadSelectPurchaseType: actions.downloadSelectPurchaseType,
        downloadPurchase: actions.downloadPurchase,
        downloadResetToLicense: actions.downloadResetToLicense,
        stripeCardInputError: actions.stripeCardInputError,
        stripeCardInputChange: actions.stripeCardInputChange,
        stripeSaveCardChange: actions.stripeSaveCardChange,
        stripeGetSavedCard: actions.stripeGetSavedCard,
        stripeUseNewCard: actions.stripeUseNewCard,
        stripeUpdateBillingInfo: actions.stripeUpdateBillingInfo
    }
)(IconPaymentForm);
